import { createSelector } from 'reselect';
import CarrierResdit7421PerformanceDetailsColumns from '../../containers/CarrierResdit7421PerformanceDetailsColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.RESDIT_74_21_PERFORMANCE_DETAILS_802.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.RESDIT_74_21_PERFORMANCE_DETAILS_802.isLoading;

export const getData =
  ReportDefinitions.RESDIT_74_21_PERFORMANCE_DETAILS_802.getDataFunction();

export const getColumns =
  createSelector(getData, CarrierResdit7421PerformanceDetailsColumns);
